var _excluded = ["kind", "description"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useEffect, useReducer } from 'react';
import { Flex } from '@grupoboticario/flora-react-flex';
import { AnimatePresence } from 'framer-motion';
import { Toast, ToastWrapper } from './Toast';
import { toastReducer, initialState as toastInitialState } from './toast-reducer';
import { styled } from '@grupoboticario/flora-react-system';
var StyledToastContainer = styled(Flex, {
  position: 'fixed',
  padding: '$1 0',
  zIndex: '$toast',
  variants: {
    origin: {
      'right-top': {
        right: 0,
        top: 0
      },
      'right-bottom': {
        right: 0,
        bottom: 0
      },
      'center-top': {
        left: '50%',
        transform: 'translateX(-50%)',
        top: 0
      }
    }
  }
});
var containers = [{
  name: 'right-top'
}, {
  name: 'right-bottom',
  invert: true
}, {
  name: 'center-top'
}];
export var ToastApp = _ref => {
  var {
    bind
  } = _ref;
  var [state, dispatch] = useReducer(toastReducer, toastInitialState);

  var removeToast = (_id, origin) => {
    dispatch({
      type: 'REMOVE_TOAST',
      payload: {
        _id,
        origin
      }
    });
  };

  var closeAll = () => {
    dispatch({
      type: 'CLOSE_ALL_TOASTS',
      payload: {}
    });
  };

  var notify = _ref2 => {
    var {
      kind,
      Icon,
      description,
      duration = 5000,
      origin = 'right-bottom',
      buttons,
      button,
      callback,
      callbacks,
      closeWhenClick = true,
      showIcon = true
    } = _ref2;

    var _id = "data-flora-" + Date.now();

    var timer = setTimeout(() => {
      removeToast(_id, origin);
    }, duration);
    dispatch({
      type: 'ADD_TOAST',
      payload: {
        description,
        variant: kind,
        buttons,
        button,
        duration,
        origin,
        timer,
        callback,
        callbacks,
        closeWhenClick,
        showIcon,
        Icon,
        _id
      }
    });
  };

  useEffect(() => {
    bind({
      notify,
      closeAll
    });
  }, []);
  var containerBoxes = containers.map(container => _extends({}, container, {
    items: state[container.name] || []
  }));
  return /*#__PURE__*/React.createElement(React.Fragment, null, containerBoxes.map(container => {
    var _container$items;

    return /*#__PURE__*/React.createElement(StyledToastContainer, {
      direction: container.invert ? 'column' : 'column-reverse',
      origin: container.name,
      key: container.name
    }, /*#__PURE__*/React.createElement(AnimatePresence, null, (_container$items = container.items) == null ? void 0 : _container$items.map(_ref3 => {
      var {
        kind,
        description
      } = _ref3,
          restToast = _objectWithoutPropertiesLoose(_ref3, _excluded);

      return /*#__PURE__*/React.createElement(ToastWrapper, {
        invert: container.invert,
        key: restToast._id
      }, /*#__PURE__*/React.createElement(Toast, _extends({
        variant: kind
      }, restToast, {
        remove: () => removeToast(restToast._id, container.name)
      }), description));
    })));
  }));
};
//# sourceMappingURL=ToastApp.js.map